(function () {
  'use strict';

  if (window.HauberCustomerPrivacyGuidance) {
    return;
  }

  var template = document.getElementById('hauber-customer-privacy-guidance-template');

  if (!template) {
    return;
  }

  function createGuidanceContent() {
    return template.content.cloneNode(true);
  }

  function createGuidance() {
    var paragraph = document.createElement('p');

    paragraph.className = 'hauber-customer-privacy-guidance';
    paragraph.setAttribute('data-hauber-customer-privacy-guidance', '');
    paragraph.appendChild(createGuidanceContent());

    return paragraph;
  }

  function findPrivacyPolicyLink(container) {
    var links = container.querySelectorAll('a[href]');

    for (var index = 0; index < links.length; index += 1) {
      try {
        var url = new URL(links[index].getAttribute('href'), window.location.origin);
        var pathname = url.pathname.replace(/\/+$/, '');

        if (pathname.endsWith('/policies/privacy-policy')) {
          return links[index];
        }
      } catch (error) {
        // Ignore malformed third-party links and leave Shopify's copy unchanged.
      }
    }

    return null;
  }

  function findLastSentenceBoundary(text) {
    var sentenceEnd = /[.!?](?:["'\u2019\u201d\u00bb])?(?=\s|$)/g;
    var match;
    var boundary = -1;

    while ((match = sentenceEnd.exec(text)) !== null) {
      boundary = match.index + match[0].length;
    }

    return boundary;
  }

  function resolveTextPosition(root, offset) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var remaining = offset;
    var node;

    while ((node = walker.nextNode())) {
      if (remaining <= node.data.length) {
        return {node: node, offset: remaining};
      }

      remaining -= node.data.length;
    }

    return null;
  }

  function replaceBannerPrivacySentence(nativeCopy, privacyLink) {
    var prefixRange = document.createRange();

    prefixRange.selectNodeContents(nativeCopy);
    prefixRange.setEndBefore(privacyLink);

    var boundary = findLastSentenceBoundary(prefixRange.toString());
    var start = boundary >= 0 ? resolveTextPosition(nativeCopy, boundary) : null;

    if (!start) {
      return;
    }

    var removalRange = document.createRange();

    removalRange.setStart(start.node, start.offset);
    removalRange.setEnd(nativeCopy, nativeCopy.childNodes.length);
    removalRange.deleteContents();

    nativeCopy.normalize();
    nativeCopy.appendChild(document.createTextNode(' '));
    nativeCopy.appendChild(createGuidanceContent());
    nativeCopy.classList.add('hauber-customer-privacy-guidance');
    nativeCopy.setAttribute('data-hauber-customer-privacy-guidance', '');
  }

  function updatePreferencesIntro() {
    var intro = document.querySelector('.shopify-pc__prefs__intro-main');

    if (!intro || intro.querySelector('[data-hauber-customer-privacy-guidance]')) {
      return;
    }

    var nativeCopy = intro.querySelector('p:not([data-hauber-customer-privacy-guidance])');

    if (nativeCopy) {
      nativeCopy.replaceWith(createGuidance());
    }

  }

  function updateBannerIntro() {
    var body = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body');

    if (!body || body.querySelector('[data-hauber-customer-privacy-guidance]')) {
      return;
    }

    var privacyLink = findPrivacyPolicyLink(body);
    var nativeCopy = privacyLink ? privacyLink.closest('p') : null;

    if (nativeCopy && body.contains(nativeCopy)) {
      replaceBannerPrivacySentence(nativeCopy, privacyLink);
    }

  }

  function updateCustomerPrivacyCopy() {
    updatePreferencesIntro();
    updateBannerIntro();
  }

  var updateQueued = false;

  function queueUpdate() {
    if (updateQueued) {
      return;
    }

    updateQueued = true;
    window.requestAnimationFrame(function () {
      updateQueued = false;
      updateCustomerPrivacyCopy();
    });
  }

  var observer = new MutationObserver(queueUpdate);

  updateCustomerPrivacyCopy();
  observer.observe(document.documentElement, {childList: true, subtree: true});

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-customer-privacy-preferences], #shopify-pc__banner__btn-manage-prefs')) {
      queueUpdate();
    }
  });

  window.HauberCustomerPrivacyGuidance = {
    refresh: updateCustomerPrivacyCopy
  };
})();
